import type { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import HelpIcon from '@mui/icons-material/Help';
import Tooltip from '@components/Tooltip';

type Props = {
    title: ReactNode;
};

export const HelpIconButton = ({ title }: Props) => (
    <Tooltip title={title} placement="top" enterTouchDelay={0}>
        <IconButton size="small">
            <HelpIcon sx={{ fontSize: '16px' }} />
        </IconButton>
    </Tooltip>
);
